import React from 'react';
import { Box, Typography, Paper, useMediaQuery, useTheme } from '@mui/material';

const PlatformRestriction: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const theme = useTheme();
  const esDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (esDesktop) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: theme.palette.background.default,
        p: 3,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" component="h1" gutterBottom sx={{ mb: 3, color: theme.palette.primary.main }}>
          Acceso No Disponible
        </Typography>
        
        <Typography variant="body1" paragraph>
          Esta aplicación está diseñada para ordenadores. Vuelve a intentarlo desde un dispositivo más grande.
        </Typography>
      </Paper>
    </Box>
  );
};

export default PlatformRestriction;
